import { CommonModule } from "@angular/common";
import { Component, input, output } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { LicenseTypes } from "@models/MasterData";
import { TranslateModule } from "@ngx-translate/core";
import { UserSectionTitle } from "@shared-mso-components/user-section-title/user-section-title";

@Component({
  standalone: true,
  selector: "free-bets-header",
  templateUrl: "free-bets-header-component.html",
  styleUrls: ["free-bets-header-component.scss"],
  imports: [IonicModule, CommonModule, UserSectionTitle, TranslateModule],
})
export class FreeBetsHeader {
  forbiddenFreebets = input.required<boolean>();
  licenseType = input.required<number>();
  onChangeHeader = output<string>();
  LicenseTypes = LicenseTypes;
}
